exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".houseModal .modal-dialog{width:80rem!important}.houseModal .switchRoomLink{font-size:2rem;position:absolute;top:25rem;color:#555;z-index:10000}.houseModal .switchRoomLink.switchRight{right:0}.houseModal .switchRoomLink.switchLeft{left:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/games/house_modal.scss
// module id = 1325
// module chunks = 0